import { reportConstants } from "../constants/reportConstants";
import { reportService } from "../../services/API/reportService";

export const reportActions = {
    getPastMonthSales,
    getRevenueSite,
    getMonth
};

function getPastMonthSales(formData){
  return dispatch => {
    reportService.getPastMonthSales(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_PAST_MONTH_SALES_DATA_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_PAST_MONTH_SALES_DATA_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_PAST_MONTH_SALES_DATA_FAILURE, error };
  }
};

function getRevenueSite(formData){
  return dispatch => {
    reportService.getRevenueSite(formData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: reportConstants.GET_REVENUE_SITE_DATA_REQUEST, data };
  }
  function success(data) {
    return { type: reportConstants.GET_REVENUE_SITE_DATA_SUCCESS, data };
  }
  function failure(error) {
    return { type: reportConstants.GET_REVENUE_SITE_DATA_FAILURE, error };
  }
};

function getMonth(){
    return dispatch => {
        reportService.getMonth().then(
        responseData => {
          dispatch(success(responseData));
        },
        error => {
          dispatch(failure(error.toString()));
        }
      );
    };
  
    function request(responseData) {
      return { type: reportConstants.GET_MONTH_REQUEST, responseData };
    }
    function success(responseData) {
      return { type: reportConstants.GET_MONTH_SUCCESS, responseData };
    }
    function failure(error) {
      return { type: reportConstants.GET_MONTH_FAILURE, error };
    }
  };


// WEBPACK FOOTER //
// ./src/app/redux/actions/reportActions.js